<div class="row question-div">
    <div class="col-12 order-2 order-xl-1" [ngClass]="{'col-xl-6':activityInfo.prompt && activityInfo?.prompt.type==='image'}" *ngIf="activityInfo.prompt && activityInfo?.prompt.type==='image'">
            <div class="prompt-container">
                    <img [alt]="activityInfo?.prompt['aria-description']" [src]="productMeta.paths['public-assets'] + '/' + activityInfo?.prompt?.url" class="img-fluid">
            </div>
    </div>
    <div class="col-12 order-xl-2 order-1" [ngClass]="{'col-xl-6':activityInfo.prompt && activityInfo?.prompt.type==='image'}">
            <div class="d-flex align-items-end">
                    <p class="question-text mb-0 mr-auto" [innerHTML]="activityInfo?.instructions"></p>
                    <p *ngIf='activityInfo["helpText"]' class="ml-2 mb-0 icon-wrapper">
                            <a href="javascript:void(0)" qid="sactivityInfo-6" *ngIf="!isHelpMessageVisible" (click)="isHelpMessageVisible = !isHelpMessageVisible">
                                    <span class="sr-only sr-only-focusable"> {{ 'SHARED.COLLAB.SCREEN_READER.HELP' | translate }} </span>
                                    <i class="nemo-font nemo-bulb help-icon" aria-hidden="true"></i>
                            </a>
                            <a href="javascript:void(0)" qid="sactivityInfo-7" *ngIf="isHelpMessageVisible" (click)="isHelpMessageVisible = !isHelpMessageVisible">
                                    <span class="sr-only sr-only-focusable"> {{ 'SHARED.COLLAB.SCREEN_READER.CROSS' | translate }} </span>
                                    <i class="nemo-font nemo-cross help-icon" aria-hidden="true"></i>
                            </a>
                    </p>
            </div>
            <div class="help-message" *ngIf="isHelpMessageVisible && activityInfo.helpText">
                    <pre class="mb-1 title" *ngIf="activityInfo.helpTitle">{{activityInfo["helpTitle"]}}</pre>
                    <pre class="mb-0 text" [innerHTML]="activityInfo?.helpText"></pre>
            </div>
    </div>
    <div class="col-12 order-3 order-xl-3" *ngIf="activityInfo.prompt && activityInfo?.prompt.type==='audio'">
        <div class="audio-container">
                <audio [attr.id]="audioPromptId" crossorigin="anonymous" aria-labelledby="psqAudioDescription"> 
                        <source [src]="productMeta.paths['public-assets'] + '/' + activityInfo?.prompt?.url" type="audio/mp3" />
                        <p id="psqAudioDescription">{{activityInfo?.prompt['aria-description']}}</p>
                </audio> 
        </div>
    </div>
</div>